import { Box, Divider, Stack, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  title: React.ReactNode;
}

export const SettingsFormSection = ({ title, children }: Props) => {
  return (
    <Box>
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>
        <Divider orientation="horizontal" sx={{ flexGrow: 1, backgroundColor: 'GrayText' }} />
      </Stack>
      <Box sx={{ marginBlock: 3 }}>{children}</Box>
    </Box>
  );
};
